import { useEffect, useState } from "react";
import { toast } from "sonner";
import { getReviewPageBackground } from "./reviewPageColours";

const SESSION_KEY = "lastReviewCustomerProviderId";

/**
 * Detects when the customer changes between reviews and triggers
 * a visual flash + toast notification.
 *
 * Uses sessionStorage to persist the previous customer across component
 * remounts (e.g. when navigating between encounters via route change).
 *
 * @param providerId - Current customer provider_id (e.g. "ELHT", "RFT"), or null
 * @returns isFlashing - true for 500ms after a customer change, for applying CSS animation
 */
export function useCustomerChangeAlert(providerId: string | null) {
  const [isFlashing, setIsFlashing] = useState(false);

  useEffect(() => {
    if (!providerId) return;

    const prev = sessionStorage.getItem(SESSION_KEY);
    sessionStorage.setItem(SESSION_KEY, providerId);

    if (prev && prev !== providerId) {
      toast.info(`Customer changed to ${providerId}`, {
        style: { backgroundColor: getReviewPageBackground(providerId) },
      });
      setIsFlashing(true);
      const timer = setTimeout(() => setIsFlashing(false), 500);
      return () => clearTimeout(timer);
    }
  }, [providerId]);

  return { isFlashing };
}
